module.exports = __webpack_public_path__ + "static/media/client.4611618e.svg";